<template>
  <div id="e3" style="margin: auto;">
    <v-fade-transition>
      <v-container fluid style="min-height: 0;" grid-list-lg v-show="stage === 1">
        <v-layout row wrap>
          <v-flex xs8>
            <el-date-picker v-model="selectedDate" type="dates" placeholder="Pick a day" :picker-options="pickerOptions1"></el-date-picker>
          </v-flex>
          <transition-group name="" tag="v-flex" class="xs4">
            <v-flex xs12 v-for="course in courses" :key="course.id">
              <v-card color="blue" class="white--text">
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline">{{ course.title}} </h3>
                    <v-chip>
                      <v-avatar class="blue white--text">{{ course.type.match(/\b(\w)/g).join('') }}</v-avatar>
                      {{ course.type }}
                    </v-chip>
                    <div>{{ course.desc }}</div>
                  </div>
                </v-card-title>
                <v-card-actions>
                  <v-btn flat dark :course="course">Register</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </transition-group>
        </v-layout>
      </v-container>
    </v-fade-transition>
    <v-fade-transition>
      <v-container fluid style="min-height: 0;" grid-list-lg v-show="stage === 2">
        <v-form>
          <bb-select-children :studentNames="studentNames"></bb-select-children>
        </v-form>
      </v-container>
    </v-fade-transition>
  </div>
</template>


<script>
import BbSelectChildren from "./fields/BbSelectChildren";

export default {
  components: {
    BbSelectChildren
  },
  data() {
    return {
      stage: 1,
      selectedCourse: null,
      studentNames: [
        "Arleen Janecek",
        "Meda Abernethy",
        "Glynis Bohland",
        "Santina Bradt",
        "Marisha Fetty",
        "Charlott Looney",
        "Sabrina Fessler",
        "Idell Burritt",
        "Josephina Darr",
        "Tajuana Karl",
        "Brittni Parchman",
        "Kiersten Billups",
        "Edmundo Alexis",
        "Angelina Brough",
        "Paris Yarnall",
        "Chantal Current",
        "Precious Koski",
        "Francina Morra",
        "Leana Amick",
        "Nancey Claflin"
      ],
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "Today",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "Yesterday",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "A week ago",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      selectedDate: []
    };
  },
  props: ["courses"],
  methods: {
    regDialog: function(event) {
      this.stage += 1;
      // this.selectedCourse = event.$ref.
    }
  }
};
</script>
